import { Link } from 'react-router-dom';
import { useEffect, useRef } from 'react';
import { CategoryType } from 'api/categories/_requests';

interface Props {
  typename: string;
  categoryType: CategoryType[];
}

const normalize = (str: string) => str?.replace(/\s+/g, '-').toLowerCase();

const CategoryTypeItem = ({ typename, categoryType }: Props) => {
  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = scrollRef.current;
    if (!container) return;

    const handleWheel = (e: WheelEvent) => {
      if (e.deltaY === 0) return;
      e.preventDefault();
      container.scrollLeft += e.deltaY;
    };

    container.addEventListener('wheel', handleWheel, { passive: false });
    return () => container.removeEventListener('wheel', handleWheel);
  }, []);

  return (
    <div
      ref={scrollRef}
      className="overflow-auto py-3 px-2"
      style={{
        scrollSnapType: 'x mandatory',
        WebkitOverflowScrolling: 'touch',
        whiteSpace: 'nowrap',
        scrollbarWidth: 'none'
      }}
    >
      <div className="d-flex flex-nowrap gap-3">
        {categoryType.map(({ _id, name, slug }) => {
          const isActive = slug === normalize(typename);

          return (
            <Link
              key={_id}
              to={`/store/${slug || 'default-category'}`}
              className={`card flex-shrink-0 text-decoration-none shadow-sm ${
                isActive ? 'border-primary' : ''
              }`}
              style={{
                scrollSnapAlign: 'start',
                minWidth: '200px',
                maxWidth: '280px',
                width: '100%',
                borderWidth: isActive ? 2 : 1
              }}
            >
              <div className="card-body d-flex align-items-center px-2 py-2">
                <img
                  src="https://cdn.moglix.com/cms/element/Images_2020-07-21_14-35-04_Images_2020-04-30_03-10-15_safety@2x.png"
                  alt={name}
                  width={64}
                  height={64}
                  className="me-3 flex-shrink-0"
                  style={{ objectFit: 'contain' }}
                  loading="lazy"
                />
                <h5
                  className="mb-0 fw-normal text-wrap"
                  style={{
                    wordBreak: 'break-word',
                    whiteSpace: 'normal',
                    color: isActive ? 'red' : undefined
                  }}
                >
                  {name}
                </h5>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default CategoryTypeItem;
